import React, { forwardRef } from 'react';

import { tw } from '../../utils/tailwind';
import { Flex, IFlex } from './Flex';

interface IStack extends IFlex {
  isInline?: boolean;
}

export const Stack: FCWithClassName<IStack> = forwardRef(
  ({ children, className, isInline = false, ...rest }, forwardedRef) => {
    return (
      <Flex
        className={tw(isInline ? 'flex-row' : 'flex-col', className)}
        ref={forwardedRef}
        {...rest}
      >
        {children}
      </Flex>
    );
  }
);

Stack.displayName = 'Stack';
